import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { Categoria } from '../../../utils/models/Categoria';
import { BusquedaProductosService } from '../../../utils/services/busqueda-productos.service';

@Component({
  selector: 'app-lista-categorias',
  templateUrl: './lista-categorias.component.html',
  styleUrls: ['./lista-categorias.component.scss']
})
export class ListaCategoriasComponent implements OnInit {
  public categorias$: Observable<Categoria>;
  @Input() public value: string;
  @Output() search: EventEmitter<any> = new EventEmitter<any>();
  moreCategorias = 5;

  constructor(
    private headerService: BusquedaProductosService,
  ) { }

  ngOnInit() {
    this.categorias$ = this.headerService.getCategoria();
    console.log(this.categorias$)
  }

  public closePanel(item: any) {
    //console.log(item)
    this.search.emit({tipo: 'categoria', item});
  }
}
